import HttpClient from "libs/utils/HttpClient";

class PinService {
  async pinExist() {
    try {
      const response = await HttpClient.get(`/api/employee/pinpassword/exist`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async addPin(body) {
    try {
      const response = await HttpClient.post(`/api/employee/pinpassword/add`, body);
      if (response.status) return response;
      return Promise.reject(response);

    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


}

export default new PinService();



